__turbopack_context__.v({
  "aligncenter": "CollectionInfoParameter-module-scss-module__HqqqgG__aligncenter",
  "alignleft": "CollectionInfoParameter-module-scss-module__HqqqgG__alignleft",
  "alignright": "CollectionInfoParameter-module-scss-module__HqqqgG__alignright",
  "content": "CollectionInfoParameter-module-scss-module__HqqqgG__content",
  "cta": "CollectionInfoParameter-module-scss-module__HqqqgG__cta",
  "ctaLink": "CollectionInfoParameter-module-scss-module__HqqqgG__ctaLink",
  "headingWrapper": "CollectionInfoParameter-module-scss-module__HqqqgG__headingWrapper",
  "heroCard": "CollectionInfoParameter-module-scss-module__HqqqgG__heroCard",
  "section": "CollectionInfoParameter-module-scss-module__HqqqgG__section",
  "text": "CollectionInfoParameter-module-scss-module__HqqqgG__text",
  "textcenter": "CollectionInfoParameter-module-scss-module__HqqqgG__textcenter",
  "textleft": "CollectionInfoParameter-module-scss-module__HqqqgG__textleft",
  "textright": "CollectionInfoParameter-module-scss-module__HqqqgG__textright",
  "wrapper": "CollectionInfoParameter-module-scss-module__HqqqgG__wrapper",
});
